import React from 'react';
import { t } from 'i18next';
import { Button } from 'drift-ui';
import styles from '../styles/ptSuccessComponent.scss';
import ptSuccessIcon from '../../../assets/images/pt-premium-success-icon.svg';

const handleGoToDashboard = () => {
  window.location.href = '/loads/dashboard';
};

export default function PtSuccessComponent() {
  return (
    <div className={styles.successContainer}>
      <img src={ptSuccessIcon} alt="Subscription successful" />
      <div className={styles.successHeader}>{t('Success!')}</div>
      <div className={styles.successSubheader}>{t('You’ve Been Upgraded to Premium.')}</div>
      <div className={styles.successDetails}>
        {t(
          'A ProTransport support representative will be in touch shortly to help answer questions and show you all that Premium has to offer.',
        )}
      </div>
      <div className={styles.successDetails}>{t('Until then, feel free to start exploring.')}</div>
      <div className={styles.returnButton}>
        <Button size="large" variant="contained" color="primary" onClick={handleGoToDashboard}>
          {t('Go to Dashboard')}
        </Button>
      </div>
    </div>
  );
}
